module.exports = __webpack_public_path__ + "d94e20c1/img/copy-icon.408fdb2d.svg";